import { render, staticRenderFns } from "./BusinessHours.vue?vue&type=template&id=fa3a0aac&scoped=true&"
import script from "./BusinessHours.vue?vue&type=script&lang=js&"
export * from "./BusinessHours.vue?vue&type=script&lang=js&"
import style0 from "./BusinessHours.vue?vue&type=style&index=0&id=fa3a0aac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3a0aac",
  null
  
)

export default component.exports